'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Card;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Card(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-card ' + className,
      width: width,
      height: height,
      viewBox: '0 0 18 18' },
    _react2.default.createElement(
      'defs',
      null,
      _react2.default.createElement('rect', { id: 'borrowing-a', width: '18', height: '14', y: '2', rx: '2' })
    ),
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('use', { fill: '', fillOpacity: '0', xlinkHref: '#borrowing-a' }),
      _react2.default.createElement('rect', { stroke: color, width: '16.5', height: '12.5', x: '.75', y: '2.75', strokeWidth: '1.5', rx: '2' }),
      _react2.default.createElement('rect', { fill: color, width: '17', height: '3', y: '6' })
    )
  );
}

Card.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Card/Card.js
// module id = 1133
// module chunks = 1